import { navigate } from '../router.js';
import { translate } from '../lib/i18n.js';

export async function renderNotFoundView(container: HTMLElement): Promise<void> {
  container.innerHTML = '';

  const view = document.createElement('div');
  view.className = 'view';
  view.innerHTML = `
    <div class="not-found">
      <div class="not-found__code">${translate('not_found.code', '404')}</div>
      <p class="not-found__message">${translate('not_found.message', 'This thread leads nowhere.')}</p>
      <button class="btn btn--ghost" style="margin-top: 1.5rem;" id="back-btn">&larr; ${translate('common.back_to_graph', 'Back to graph')}</button>
    </div>
  `;

  container.appendChild(view);

  (view.querySelector('#back-btn') as HTMLButtonElement).addEventListener('click', () => navigate('/graph'));
}
